import { useState } from "react";
import RegistroPortal from "../componentes/RegistroPortal";
import SecaoPreparador from "./SecaoPreparador";
import ProximasCompeticoes from "../componentes/ProximasCompeticoes";
import SecaoTreinoFisicoConfig from "./SecaoTreinoFisicoConfig";
import SecaoPresencaFisica from "./SecaoPresencaFisica";
import SecaoComprovantes from "./SecaoComprovantes";
import SecaoPlanejamento from "./SecaoPlanejamento";
import SecaoPlanilhaTreino from "./SecaoPlanilhaTreino";
import { Abas } from "../componentes";

// Tela do PREPARADOR FÍSICO e AUXILIAR. Reúne, em sub-abas:
//  - Meu registro: registra a própria presença (equipe técnica).
//  - Presença física: marca presença/falta dos atletas no treino físico
//    (segunda linha, informativa — não afeta a frequência oficial).
//  - Dias de treino: configura o calendário semanal do treino físico.
// O painel de presença física e a configuração são exclusivos do preparador
// e do auxiliar. Os coordenadores apenas visualizam (em outra tela).
export default function TelaPreparador({ uid, userNucleo, podeConfigurar = true }) {
  const [aba, setAba] = useState("registro");

  // Dias de treino vem logo depois da presença: é o calendário que decide
  // quais dias a tela de presença mostra, então os dois se explicam juntos.
  // Justificativa é leitura, e leitura fica por último.
  const abas = [
    { id: "registro", icone: "rosto", label: "Meu registro" },
    { id: "presenca_fisica", icone: "halter", label: "Presença do treino físico" },
    // Planejamento e planilha andam juntos e nessa ordem: o plano combina o
    // mês e o microciclo, a planilha detalha o que foi combinado.
    { id: "planejamento", icone: "grade", label: "Planejamento" },
    { id: "planilha", icone: "prancheta", label: "Planilha de treino" },
  ];
  if (podeConfigurar) abas.push({ id: "dias_treino", icone: "calendario", label: "Dias de treino" });
  // Sem modalidade de propósito: a preparação física atende a turma inteira,
  // então vê a justificativa de qualquer modalidade. O técnico vê só a dele,
  // na tela dele.
  abas.push({ id: "comprovantes", icone: "check", label: "Faltas abonadas" });

  return (
    <div>
      <Abas abas={abas} ativa={aba} onEscolher={setAba} />

      {aba === "registro" && (
        <div>
          <div style={{ marginBottom: 18 }}>
            <RegistroPortal uid={uid} userNucleo={userNucleo} modoEquipe={true} />
          </div>
          <SecaoPreparador userNucleo={userNucleo} />
        </div>
      )}

      {aba === "presenca_fisica" && (
        <SecaoPresencaFisica userNucleo={userNucleo} podeMarcar={true} />
      )}

      {aba === "planejamento" && (
        <SecaoPlanejamento userNucleo={userNucleo} />
      )}

      {aba === "planilha" && (
        <SecaoPlanilhaTreino userNucleo={userNucleo} />
      )}

      {/* A preparação física vê QUEM está abonado e em QUE dia, para acertar
          a frequência do treino físico. O motivo é dado de saúde na maior
          parte dos casos, e o setor faz o que precisa fazer sem ele. */}
      {aba === "comprovantes" && (
        <SecaoComprovantes userNucleo={userNucleo} somenteAbonadas={true} />
      )}

      {aba === "dias_treino" && podeConfigurar && (
        <SecaoTreinoFisicoConfig userNucleo={userNucleo} />
      )}

      {/* A agenda do que ainda vai acontecer, no fim da página.
          São as mesmas competições cadastradas em Competições e
          resultados: não há segunda agenda a manter. Quem vê o quê é
          decidido no servidor. */}
      <ProximasCompeticoes />
    </div>
  );
}
